export const LABELS = {
  stations: 'header.stations',
  stationDetails: 'header.station_details',
  passengerMonitor: 'header.passenger_monitor',
  rhbMonitor: 'header.rhb_monitor',
  incidents: 'header.incidents',
  incidentsDetails: 'header.incident_details',
  otherRelatedIncidents: 'incidents.other_related',
};

export const INCIDENT_CAUSE_TRANSLATION_KEY: Record<string, string> = {
  POLICE_ACTIVITY: 'incidents.causes.police_activity',
  WEATHER: 'incidents.causes.weather',
  OTHER_CAUSE: 'incidents.causes.other_cause',
  ACCIDENT: 'incidents.causes.accident',
  TECHNICAL_PROBLEM: 'incidents.causes.technical_problem',
  CONSTRUCTION: 'incidents.causes.construction',
  MAINTENANCE: 'incidents.causes.maintenance',
};

export const ERROR_FEEDBACK = {
  general: 'errors.general',

  release_note: {
    api: 'errors.release_note.api',
    create_error: 'errors.release_note.create_error',
    description: 'errors.release_note.description',
    empty: 'errors.release_note.empty',
  },
  stations: {
    api: 'errors.stations.api',
    empty: 'errors.stations.empty',
    description: 'errors.stations.description',
  },

  stationDetails: {
    api: 'errors.stations.details_api',
  },

  routeDetails: {
    api: 'errors.routes.details_api',
  },

  routes: {
    empty: 'errors.routes.empty',
    description: 'errors.routes.description',
    api: 'errors.routes.api',
  },
  crew: {
    api: 'errors.crew.api',
    empty: 'errors.crew.empty',
    description: 'errors.crew.description',
  },
  reservation: {
    empty: 'errors.reservations.empty',
    description: 'errors.reservations.description',
    api: 'errors.reservations.api',
  },

  pearlChain: {
    empty: 'errors.pearl_chain.empty',
    description: 'errors.pearl_chain.description',
    api: 'errors.pearl_chain.api',
  },

  incidents: {
    search: 'errors.incidents.search',
    empty: 'errors.incidents.empty',
    api: 'errors.incidents.api',
  },
  monitors: {
    api: 'errors.monitors.api',
    empty: 'errors.monitors.empty',
    description: 'errors.monitors.description',
  },
  departures: {
    empty: 'errors.departures.empty',
    description: 'errors.departures.description',
    api: 'errors.departures.api',
  },
  arrivals: {
    empty: 'errors.arrivals.empty',
    description: 'errors.arrivals.description',
    api: 'errors.arrivals.api',
  },
  stationInformation: {
    api: 'errors.information.api',
    empty: 'errors.information.empty',
    description: 'errors.information.description',
  },
  map: {
    api: 'errors.map.api',
  },
  services: {
    empty: 'errors.information.empty',
    description: 'errors.services.description',
  },
  ladder: {
    api: 'errors.ladder.api',
  },
  vehicle: {
    empty: 'errors.vehicle.empty',
    description_passenger: 'errors.vehicle.description_passenger',
    description_non_passenger: 'errors.vehicle.description_non_passenger',
    api: 'errors.vehicle.api',
  },
  interface_status: {
    api: 'errors.interface_status.api',
  },
};

export const FILTER_SORT_BY = {
  LINE_NUMBER: 'line_number',
  TRAIN_NUMBER: 'train_number',
  DEVIATION: 'deviation',
};

export const FILTER_STATUS = {
  ALL: 'all',
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  COCKPIT_RIDES: 'has_cockpit_reservation',
  COMPLETED: 'completed',
  DANGEROUS_GOODS: 'has_dangerous_goods',
};

export const CALL_DRAWER_ITEM_TYPES = { call: 'call', copy: 'copy' };

export type CallDrawerItemType =
  (typeof CALL_DRAWER_ITEM_TYPES)[keyof typeof CALL_DRAWER_ITEM_TYPES];

export const INCIDENT_DETAILS = 'INCIDENT_DETAILS';
export const INCIDENT_FILTER = 'INCIDENT_FILTER';
export const INCIDENTS_LIST = 'INCIDENTS_LIST';
export const ROUTE_DETAILS = 'ROUTE_DETAILS';
export const STATION_DETAILS = 'STATION_DETAILS';
export const ROUTE_LIST = 'ROUTE_LIST';
export const MONITOR = 'MONITOR';
export const LIST = 'LIST';
export const FREE_OF_CHARGE = 'free of charge';

export const DEVIATION_THRESHOLDS = {
  EARLY: 0,
  ON_TIME: 3,
  DELAYED: 5,
} as const;

export const DEVIATION_BACKGROUND_COLORS = {
  EARLY: 'bg-deviation-early',
  ON_TIME: 'bg-deviation-ontime',
  DELAYED: 'bg-deviation-delay',
  TOO_LATE: 'bg-deviation-too-late',
} as const;

export const FINISHED_TRAIN_BACKGROUND_COLOR = 'bg-surface-border-dark';
export const SIGNED_ON_COLOR = 'bg-deviation-5-minute-early-subtle';

export const MEDIUM_DATE_FORMAT = 'dd MMM yyyy'; // 20 Jan 2026
export const RELEASE_NOTE_SHORT_DATE = 'dd MMM, yyyy';
export const RELEASE_NOTE_LONG_DATE = 'dd MMMM, yyyy';
export const SHORT_TIME_FORMAT = 'hh:mm a'; // 02:30 PM

export const UNKNOWN_CAUSE = 'UNKNOWN_CAUSE';
export const UNKNOWN_EFFECT = 'UNKNOWN_EFFECT';

export const TAB_VALUES = {
  ARRIVALS: 'arrivals',
  DEPARTURES: 'departures',
  INFORMATION: 'information',
} as const;

export const TAB_LABELS = {
  ARRIVALS: 'tabs.arrivals',
  DEPARTURES: 'tabs.departures',
  INFORMATION: 'tabs.information',
} as const;

export const OTHER_RELATED_INCIDENTS = 'other-related-incidents';

//TODO: Need to check for optimization
export const TODAY = new Date(
  Date.UTC(new Date().getUTCFullYear(), new Date().getUTCMonth(), new Date().getUTCDate())
);

export const ROLES: Record<string, string> = {
  CREW: 'dienst',
  RESERVATION: 'reservation',
  WEBCAM: 'webcam',
  WELLDEV: 'welldev',
  ADMIN: 'admin',
};

export const PASSENGER_TRAIN = 'passenger_train';
export const CAR_TRAIN = 'car_train';
export const VEREINA_STATUS_DISRUPT = '!';
export const VEREINA_STATUS_INACTIVE = '-';

export const VEHICLE_TYPE_COCKPIT = 'Cockpit Wagon';

export const SPLASH_SCREEN_ANIMATION_DURATION = 1500;

export const TRAIN_STATUS_MAP: Record<string, string> = {
  CANCELLED: 'Cancelled',
  COMPLETED: 'Completed',
  IN_PROGRESS: 'JOURNEY_STATUS.IN_PROGRESS',
  EXPECTED: 'Expected',
};

export const VEHICLE_FEATURES = ['dine', 'closedVehicle', 'vehicleLowFloor', 'hasToilet'] as const;

export const INTERFACE_STATUS_DOT: Record<string, string> = {
  success: 'bg-deviation-ontime',
  partially_success: 'bg-deviation-delay',
  failed: 'bg-deviation-too-late',
};

export const INTERFACE_STATUS_BADGE: Record<string, { className: string; label: string }> = {
  success: {
    className: 'bg-deviation-ontime-subtle text-deviation-ontime-subtle-foreground',
    label: 'interface_status.system.success',
  },
  partially_success: {
    className: 'bg-deviation-delay-subtle text-deviation-delay-subtle-foreground',
    label: 'interface_status.system.partially_success',
  },
  failed: {
    className: 'bg-deviation-too-late-subtle text-deviation-too-late-subtle-foreground',
    label: 'interface_status.system.failed',
  },
};

export const TIME_CONSTANTS = {
  MS_IN_SECOND: 1000,
  SECONDS_IN_MINUTE: 60,
  SECONDS_IN_HOUR: 3600,
  SECONDS_IN_DAY: 86400,
  MIN_SECONDS_THRESHOLD: 10,
};

export const SEAT_CLASS = {
  FIRST: 'first',
  SECOND: 'second',
  MIXED: 'mixed',
} as const;

export const DESIGNATION_LABELS: Record<string, string> = {
  RB: 'common.driver',
  LP: 'common.driver',
  ANW: 'common.anwaerter',
  ZP: 'common.crew',
  FZ: 'common.fahrgastzaehlung',
};

export const DESIGNATION_SORT: Record<string, number> = {
  RB: 0,
  LP: 0,
  ANW: 1,
  ZP: 2,
  FZ: 3,
};

export const JOURNEY_STATE = {
  PENDING: 'Pending',
  IN_PROGRESS: 'InProgress',
  SIGNED_ON: 'SignedOn',
};

export const INTERFACE_STATUS = 'interface-status';
export const RELEASE_NOTES = 'release-notes';
